import React from 'react'
import styled, { css } from 'styled-components'

export type Props = {
  currentStep: number
}

const StyledSteps = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledStep = styled.div<{ isActive: boolean }>`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: ${props => props.theme.members.colors.silver._70};
  color: ${props => props.theme.members.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  line-height: 1;
  gap: 2px;
  position: relative;

  ${({ isActive }) =>
    isActive && css`
      background-color: ${props => props.theme.members.colors.appleGreen._60};

      ${StyledStepName} {
        color: ${props => props.theme.members.colors.black._100};
        font-weight: 700;
      }
    `
  }

  @media ${props => props.theme.media.sm} {
    width: 80px;
    height: 80px;
  }
`

const StyledStepText = styled.div`
  font-size: 11px;
  font-weight: 700;

  @media ${props => props.theme.media.sm} {
    font-size: 14px;
  }
`

const StyledStepNumber = styled.div`
  font-size: 20px;

  @media ${props => props.theme.media.sm} {
    font-size: 28px;
  }
`

const StyledConnector = styled.div<{ isActive: boolean }>`
  width: 1.25rem;
  height: .25rem;
  background-color: ${props => props.theme.members.colors.silver._30};

  ${({ isActive }) =>
    isActive && css`
      background-color: ${props => props.theme.members.colors.appleGreen._60};
    `
  }

  @media ${props => props.theme.media.sm} {
    width: 3rem;
  }
`

const StyledStepName = styled.div`
  font-size: 10px;
  position: absolute;
  top: 100%;
  margin-top: .5rem;
  color: ${props => props.theme.members.colors.black._60};

  @media ${props => props.theme.media.sm} {
    font-size: 12px;
  }
`

export const StyledSubHeader: React.FC<Props> = (props: Props) => {
  const isActiveStep = (step: number) => step <= props.currentStep

  return(
    <StyledSteps>
      <StyledStep isActive={isActiveStep(1)} data-cy='step-status-1'>
        <StyledStepText>STEP</StyledStepText>
        <StyledStepNumber>1</StyledStepNumber>
        <StyledStepName>現在のご状況</StyledStepName>
      </StyledStep>
      <StyledConnector isActive={isActiveStep(2)} />
      <StyledStep isActive={isActiveStep(2)} data-cy='step-status-2'>
        <StyledStepText>STEP</StyledStepText>
        <StyledStepNumber>2</StyledStepNumber>
        <StyledStepName>案件のご条件</StyledStepName>
      </StyledStep>
      <StyledConnector isActive={isActiveStep(3)} />
      <StyledStep isActive={isActiveStep(3)} data-cy='step-status-3'>
        <StyledStepText>STEP</StyledStepText>
        <StyledStepNumber>3</StyledStepNumber>
        <StyledStepName>経験スキル</StyledStepName>
      </StyledStep>
      <StyledConnector isActive={isActiveStep(4)} />
      <StyledStep isActive={isActiveStep(4)} data-cy='step-status-4'>
        <StyledStepText>STEP</StyledStepText>
        <StyledStepNumber>4</StyledStepNumber>
        <StyledStepName>その他</StyledStepName>
      </StyledStep>
    </StyledSteps>
  )
}
